/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable */
// @ts-nocheck

import React, { useContext, useEffect, useState } from "react";
import OrgContext from "../../store/orgContext";
import {
  BULK_UPLOAD_GENERAL_TRANSLATIONS,
  CREATE_DFSI_GROUP_TRANSLATIONS,
} from "../../translations/util";
import Tabs from "../../ui/tabs/Tabs";
import TabPanels from "../../ui/tabs/TabPanels";
import TabPanel from "../../ui/tabs/TabPanel";
import Button, { Icons } from "../buttons/Button";
import { errorAlert, makeApiRequest, successAlert } from "../../util";
import { requestNewBodyforBulkUpload } from "../../util/bulkUploadFileValidation";
import AuthContext from "../../store/authContext";
import {
  handleFileChosen,
  handleTabMovement,
  csvmaker,
  downloadCSV,
  processErrorReport,
  handleFileRead,
  readChosenFile,
} from "./helper";
import BulkUploadTabList from "../../ui/tabs/BulkUploadTabList";
import BulkUploadModal, {
  BulkUploadModalIcons,
} from "../modal/BulkUploadModal";
import ErrorReportPanel from "./ErrorReportPanel";
import ImportFile from "./ImportFile";
import {
  LMRGroupsAdd,
  LMRUsersAdd,
  MCGroupsAdd,
  MCUsersAdd,
} from "../../api/icCheck";
import DFSIContext from "../../store/dfsiContext";
import InfoAlert from "../../ui/InfoAlert";

interface IProps {
  moduleName: string;
  pathName: string;
  csvTemplateFile: string[];
  closeBulkUploadSidePanel: () => void;
  notes?: string[];
}

const BulkUpload = ({
  moduleName,
  pathName,
  csvTemplateFile,
  closeBulkUploadSidePanel,
  notes,
}: IProps) => {
  const { selectedOrg } = useContext(OrgContext);
  const { token, bulkLimit } = useContext(AuthContext);
  const { dfsiConnectionData, iwfID, dfsiChannelData, allDFSIconnections } =
    useContext(DFSIContext);
  const [steps, setSteps] = useState(0);
  const [startUploading, setStartUploading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [errorFile, setErrorFile] = useState([]);
  const [validatedFile, setValidatedFile] = useState([]);
  const [successFile, setSuccessFile] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [count, setCount] = useState(1);
  const [isBulkLimitReached, setIsBulkLimitReached] = useState(false);
  const [isColumnMistached, setIsColumnMistached] = useState(false);

  const BULK_TABS_LIST = [
    {
      tabName: BULK_UPLOAD_GENERAL_TRANSLATIONS.TabList.tabName.import,
      classname: fileName ? "completed-step" : "uncompleted-step",
      showCheckmark: fileName,
    },
    {
      tabName: BULK_UPLOAD_GENERAL_TRANSLATIONS.TabList.tabName.upload,
      classname:
        handleTabMovement({
          steps,
          showReport,
          fileName,
        }) && steps === 2
          ? "completed-step"
          : "uncompleted-step",
      showCheckmark:
        handleTabMovement({
          steps,
          showReport,
          fileName,
        }) && steps === 2,
    },
    {
      tabName: BULK_UPLOAD_GENERAL_TRANSLATIONS.TabList.tabName.report,
      classname:
        handleTabMovement({
          steps,
          showReport,
          fileName,
        }) && steps === 2
          ? "completed-step"
          : "uncompleted-step",
      showCheckmark:
        handleTabMovement({
          steps,
          showReport,
          fileName,
        }) && steps === 2,
    },
  ];

  //This function helps to download error report
  const handleDownloadErrorReport = (
    moduleName: string,
    errorFile: Record<string, any>[] = [],
  ) => {
    let csvRows = [];
    const timeStamp = new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000,
    )
      .toISOString()
      .slice(0, -1);

    csvRows = processErrorReport(errorFile);

    // To Download the CSV file
    downloadCSV(
      csvRows.join("\n"),
      `ICAT_${moduleName.split(" ").join("")}s_ErrorReport_${timeStamp}.csv`,
    );
  };

  // This function handles the file validation and uploading
  const handleFileUpload = async (entry: any) => {
    try {
      let requestBody = await requestNewBodyforBulkUpload[moduleName](
        entry,
        selectedOrg?.id,
        iwfID,
      );
      let body = JSON.stringify(requestBody);
      let params = {
        path: pathName,
        method: "POST",
        body: body,
        token,
      };
      if (
        ["Organisation", "Location", "Organisation Mapping"].includes(
          moduleName,
        )
      ) {
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          emptyResponse: true,
        });
      } else if (["Organisation Translation"].includes(moduleName)) {
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          emptyResponse: true,
          org: selectedOrg.id,
        });
      } else if (["LMR User"].includes(moduleName)) {
        await LMRUsersAdd({
          data: JSON.stringify({
            "LMR-ID": requestBody["LMR-ID"],
            "MAPPED-MCPTT-ID": requestBody["MAPPED-MCPTT-ID"],
          }),
          org: selectedOrg.id,
          token,
        });
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          org: selectedOrg.id,
        });
      } else if (["LMR Group"].includes(moduleName)) {
        await LMRGroupsAdd({
          data: JSON.stringify({
            "TG-ID": requestBody["TG-ID"],
            "MAPPED-MCPTT-GID": requestBody["MAPPED-MCPTT-GID"],
          }),
          org: selectedOrg.id,
          token,
        });
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          org: selectedOrg.id,
        });
      } else if (["MCPTT User"].includes(moduleName)) {
        await MCUsersAdd({
          data: JSON.stringify({
            "MCPTT-ID": requestBody["MCPTT-ID"],
            ...(requestBody &&
              requestBody["MAPPED-P25-ID"] && {
                "MAPPED-P25-ID": requestBody["MAPPED-P25-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-DMR-ID"] && {
                "MAPPED-DMR-ID": requestBody["MAPPED-DMR-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-ROIP-ID"] && {
                "MAPPED-ROIP-ID": requestBody["MAPPED-ROIP-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-DFSI-ID"] && {
                "MAPPED-DFSI-ID": requestBody["MAPPED-DFSI-ID"],
              }),
          }),
          org: selectedOrg.id,
          token,
        });
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          org: selectedOrg.id,
        });
      } else if (["MCPTT Group"].includes(moduleName)) {
        await MCGroupsAdd({
          data: JSON.stringify({
            "MCPTT-GID": requestBody["MCPTT-GID"],
            ...(requestBody &&
              requestBody["MAPPED-P25-TG-ID"] && {
                "MAPPED-P25-TG-ID": requestBody["MAPPED-P25-TG-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-DMR-TG-ID"] && {
                "MAPPED-DMR-TG-ID": requestBody["MAPPED-DMR-TG-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-ROIP-TG-ID"] && {
                "MAPPED-ROIP-TG-ID": requestBody["MAPPED-ROIP-TG-ID"],
              }),
            ...(requestBody &&
              requestBody["MAPPED-DFSI-TG-ID"] && {
                "MAPPED-DFSI-TG-ID": requestBody["MAPPED-DFSI-TG-ID"],
              }),
          }),
          token,
          org: selectedOrg.id,
        });
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          org: selectedOrg.id,
        });
      } else {
        let response = await makeApiRequest<{ Ref: string }>({
          ...params,
          org: selectedOrg.id,
        });
      }
      successFile.push(entry);
      setCount((count) => count + 1);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (moduleName === "XSSI Connection") {
        let newObj = { ...entry };
        const maxIndex = Math.max(
          newObj["IWF-GROUP-RANGES"].length,
          newObj["RADIO-GROUP-RANGES"].length,
          newObj["UNIT-RANGES"].length,
          1,
        );
        let transformedObject = {};
        [...Array(maxIndex).keys()].map((ind) => {
          transformedObject = {
            ...newObj,
            "IWF-MAX-RANGE": newObj["IWF-GROUP-RANGES"][ind]
              ? newObj["IWF-GROUP-RANGES"][ind]["GROUP-MAX-ID"]
              : "",
            "IWF-MIN-RANGE": newObj["IWF-GROUP-RANGES"][ind]
              ? newObj["IWF-GROUP-RANGES"][ind]["GROUP-MIN-ID"]
              : "",
            "RADIO-MAX-RANGE": newObj["RADIO-GROUP-RANGES"][ind]
              ? newObj["RADIO-GROUP-RANGES"][ind]["GROUP-MAX-ID"]
              : "",
            "RADIO-MIN-RANGE": newObj["RADIO-GROUP-RANGES"][ind]
              ? newObj["RADIO-GROUP-RANGES"][ind]["GROUP-MIN-ID"]
              : "",
            "UNIT-MAX-RANGE": newObj["UNIT-RANGES"][ind]
              ? newObj["UNIT-RANGES"][ind]["UNIT-MAX-ID"]
              : "",
            "UNIT-MIN-RANGE": newObj["UNIT-RANGES"][ind]
              ? newObj["UNIT-RANGES"][ind]["UNIT-MIN-ID"]
              : "",
            reason: `"${e}"`,
          };

          delete transformedObject["IWF-GROUP-RANGES"];
          delete transformedObject["RADIO-GROUP-RANGES"];
          delete transformedObject["UNIT-RANGES"];
          errorFile.push(transformedObject);
        });
      } else {
        let newObj = { ...entry, reason: `"${e}"` };
        errorFile.push(newObj);
      }
      setCount((count) => count + 1);
    }
  };

  const handleFileSubmit = async () => {
    let result;
    try {
      if (validatedFile.length > 0) {
        setCount(file.length - validatedFile.length);
      } else {
        setCount(-1); // this condition will take care of empty validation file ie., if all entries fail to validate
      }
      setShowBulkUploadModal(true);
      setDataLoading(true);
      await Promise.allSettled(
        validatedFile?.map((entry) => handleFileUpload(entry)),
      );
      if (successFile.length > 0) {
        successAlert(
          `${
            successFile.length
          } ${moduleName.toLowerCase()} records created successfully`,
        );
      } else {
        if (
          !isBulkLimitReached &&
          !isColumnMistached &&
          errorFile.length !== 0
        ) {
          errorAlert(
            BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData.errorMessage,
          );
        }
      }
    } catch (e) {
      setErrorFile([...errorFile]);
    } finally {
      setDataLoading(false);
      if (!showBulkUploadModal) {
        setSteps((prevSteps) => prevSteps + 1);
        setShowReport(true);
      }
    }
  };

  // This function will remove/delete the file and reset the state
  const handleFileDelete = () => {
    setFile([]);
    setRowCount(0);
    setValidatedFile([]);
    setFileName("");
    setErrorFile([]);
    setSuccessFile([]);
    setSteps((prevSteps) => prevSteps - 1);
    setFileType("");
    setIsBulkLimitReached(false);
    setIsColumnMistached(false);
    setShowReport(false);
    setIsBulkLimitReached(false);
  };

  const handleDFSIData = () => {
    if (moduleName === "DFSI Connection") {
      return allDFSIconnections;
    }
    if (moduleName === "DFSI Channel") {
      return dfsiConnectionData;
    }
    if (moduleName === "DFSI Group") {
      return dfsiChannelData;
    }
  };
  const handleFileReadandParsing = (fileData) => {
    setFileName(fileData.name);
    setFileType(fileData.type);
    readChosenFile(
      fileData,
      setFile,
      setRowCount,
      setErrorFile,
      setValidatedFile,
      moduleName,
      bulkLimit,
      setIsBulkLimitReached,
      setIsColumnMistached,
      csvTemplateFile,
      handleDFSIData(),
    );
    setSteps((prevSteps) => prevSteps + 1);
  };

  useEffect(() => {
    setStartUploading(false);
  }, [file]);

  useEffect(() => {
    setDataLoading(false);
  }, [successFile, errorFile]);

  return (
    <>
      <aside
        id="bulk-upload-sidepanel"
        data-cy="bulk-upload-sidepanel"
        className="bulk-upload-sidepanel sidepanel small-sidepanel fixed z-40 h-full transform transition-transform ease-in duration-150 bg-white"
      >
        <div className="panel-header">
          <div className="panel-left-side">
            <Button
              kind="ghost"
              className="close-btn"
              icon={Icons.Close}
              onClick={() => closeBulkUploadSidePanel()}
              dataCy="closeBulkUploadPage-"
            />
            <h5 data-cy="bulkUpload-panelName">
              {" "}
              {BULK_UPLOAD_GENERAL_TRANSLATIONS.handleBulkUploadPageHeaderText(
                moduleName,
              )}{" "}
            </h5>
          </div>
        </div>
        {moduleName === "DFSI Group" && selectedOrg && !iwfID ? (
          <div className="main-content my-8 mx-4">
            <InfoAlert
              heading={
                CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingIWFBulk.heading
              }
              subText={
                CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingIWFBulk.subText
              }
            />
          </div>
        ) : (
          <div className="data-tabs bulk-upload-tabs">
            <Tabs
              selectedIndex={steps}
              onChange={({ selectedIndex }: { selectedIndex: number }) =>
                setSteps(selectedIndex)
              }
            >
              <div className="data-tablist bulk-upload-tablist">
                <BulkUploadTabList
                  TABS_LIST={BULK_TABS_LIST}
                  fileName={fileName}
                  showCheckmark={handleTabMovement({
                    steps,
                    showReport,
                    fileName,
                  })}
                  steps={steps}
                />
              </div>
              <TabPanels>
                <TabPanel>
                  <div
                    className="data-tabcontent bulk-upload-tabcontent"
                    data-cy="import-section"
                  >
                    <ImportFile
                      labelText={
                        BULK_UPLOAD_GENERAL_TRANSLATIONS.DragnDropLabelText
                      }
                      onAddFiles={(fileData) =>
                        handleFileReadandParsing(fileData)
                      }
                      handleDownloadTemplate={() =>
                        downloadCSV(
                          csvTemplateFile.join(","),
                          `${moduleName.split(" ").join("")}csvTemplate.csv`,
                        )
                      }
                      handleFileDelete={handleFileDelete}
                      handleFileSubmit={handleFileSubmit}
                      filename={fileName}
                      dataLoading={dataLoading}
                      showReport={showReport}
                      fileType={fileType}
                      isColumnMistached={isColumnMistached}
                      isBulkLimitReached={isBulkLimitReached}
                      notes={notes}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="data-tabcontent bulk-upload-tabcontent"
                    data-cy="upload-section"
                  >
                    <ImportFile
                      labelText={
                        BULK_UPLOAD_GENERAL_TRANSLATIONS.DragnDropLabelText
                      }
                      onAddFiles={(fileData) =>
                        handleFileReadandParsing(fileData)
                      }
                      handleDownloadTemplate={() =>
                        downloadCSV(
                          csvTemplateFile.join(delimiter),
                          `${moduleName.split(" ").join("")}csvTemplate.csv`,
                        )
                      }
                      handleFileDelete={handleFileDelete}
                      handleFileSubmit={handleFileSubmit}
                      filename={fileName}
                      dataLoading={dataLoading}
                      showReport={showReport}
                      fileType={fileType}
                      isColumnMistached={isColumnMistached}
                      isBulkLimitReached={isBulkLimitReached}
                      notes={notes}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <ErrorReportPanel
                    showReport={showReport}
                    totalConnections={file.length}
                    totalConnectionsCreated={successFile.length}
                    totalErrors={errorFile.length}
                    fileName={fileName}
                    moduleName={moduleName}
                    onClick={() =>
                      handleDownloadErrorReport(moduleName, errorFile)
                    }
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </div>
        )}
      </aside>
      <BulkUploadModal
        modalHeaderText={
          BULK_UPLOAD_GENERAL_TRANSLATIONS.BulkUploadModal.header
        }
        modalDescriptionText={
          BULK_UPLOAD_GENERAL_TRANSLATIONS.BulkUploadModal.descriptionText
        }
        open={showBulkUploadModal}
        setOpen={setShowBulkUploadModal}
        cancelIcon={BulkUploadModalIcons.Caution}
        maxRowCount={rowCount}
        moduleName={moduleName}
        count={count}
      />
    </>
  );
};

export default BulkUpload;
